module.exports = __webpack_public_path__ + "static/img/电话@3x.dad3e6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/plugins/dialog/assets/电话@3x.png
// module id = 355
// module chunks = 363 364